import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'utils/moment';
import Loading from '../../../../components/loading';
import DetailPage from '../../../../components/moduleBuilder/DetailPage';
import icon from '../../../../icons/violation.png';
import { getApiBaseUrl } from '../../../../constants/apiEnv';
import { appealViolation } from '../../redux/action';

const Detail = (props) => {
  const { match: { params: { id } } } = props;
  const dispatch = useDispatch();
  const baseURL = getApiBaseUrl() ? getApiBaseUrl() : 'https://api.us.aerosimple.com/api';
  const jwtToken = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    Authorization: jwtToken
  };
  const profile = useSelector(state => state.auth.profile);
  const violationAppealAction = useSelector(state => state.permitManagement.violationAppealAction);
  const [logData, setLogData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(true);
  const [tableHeaders, setTableHeaders]= useState([
    ['created_at', 'date'],
    ['map', 'Map'],
    ['violation_at', `${profile.permit_management?.violations || 'Violation'} at`],
    ['badge_no', `${profile.permit_management?.badge || 'Badge'} Number`],
    ['type', 'Category'],
    ['sub_type', 'Offence'],
    ['points', 'Points'],
    ['warning_only', 'Warning/ Penalty']
  ]);

  const runDetailAPI=() => {
    setLoader(true);
    Axios.get(`${baseURL}/app/violations/${id}/violation_detail`, { headers })
    .then((res) => {
        setLogData(res.data|| []);
        setLoader(false);
        setError(false);
        setTableHeaders([...tableHeaders]);
      })
    .catch(() => {
      setLoader(false);
      setError(true);
      toast.error('Please try again later');
    });
  };

  const callAppealApi=(appealMsg) => {
    dispatch(appealViolation(id, { 'description': appealMsg }));
  };

  const checkAppealExpiry=() => {
    const today = moment();
    if (today.diff(logData.created_at, 'days')<=7) {
      return true;
    }
    return false;
  };
  useEffect(() => {
      runDetailAPI();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (violationAppealAction.success === true) {
      runDetailAPI();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [violationAppealAction]);

  return (
    <>
      <Loading loadingStatus={loader} />
      <DetailPage
        backRoute="/avp/violations"
        logData={logData}
        tableHeadders={tableHeaders}
        sectionHeader={{ default: profile?.permit_management?.violations || 'Violations', id: ' ' }}
        panelHeading={{ default: `${profile.permit_management?.violations || 'Violation'} Details`, id: ' ' }}
        icon={icon}
        adpComments={false}
        profile={profile}
        error={error}
        callAppealApi={callAppealApi}
        checkAppealExpiry={checkAppealExpiry()}
        actionBtn
        forViolations
        changePermissions={profile?.permissions?.vehicle_permit?.includes('change_vehiclepermit')}
        {...props}
      />
    </>
  );
};

export default Detail;
